import PropTypes from 'prop-types'
import { withStyles } from '@aura/components/styles'
import Link from '@aura/components/link'
import Grid from '@aura/components/grid'
import Box from '@aura/components/box'
import Typography from '@aura/components/typography'
import Button from '@aura/components/button'
import { useAuraThemeSwitcher } from '@aura/components/themes'
import { useTranslation } from 'react-i18next'
import AppBar from '../app-bar-tool'
import Footer from '../footer-new'
import SUPPORTED_THEMES from '../../constants/theme'
import styles from './styles'


const TIMEOUT_ILLUSTRATIONS = {
    [SUPPORTED_THEMES.DARK]: '/img/noAccess_light.svg',
    [SUPPORTED_THEMES.LIGHT]: '/img/noAccess.svg'
}


const Component = ({
    classes
}) => {

    const { t: translate } = useTranslation()
    const { theme } = useAuraThemeSwitcher()
    const paletteMode = theme?.palette?.mode
    const title = translate('noAccess.title1')
    const verbiage1 = translate('noAccess.verbiage01')
    const verbiage2 = translate('noAccess.verbiage2')
    const verbiage = <div>{verbiage1} <Link target="_blank" rel="noopener noreferrer" href={window.location.origin}>{window.location.origin}</Link>.{verbiage2}</div>
    const timeoutIllustration = TIMEOUT_ILLUSTRATIONS[paletteMode] || TIMEOUT_ILLUSTRATIONS[SUPPORTED_THEMES.LIGHT]


    return (
        <>
            <AppBar />
            <Grid container className={classes.gridContainerCenter}>
                <Grid className={classes.noAccessRoot} md={5} sm={8} xs={12}>
                    <Box className={classes.header}>
                        <Box className={classes.illustrationWrapper}>
                            <Box className={classes.illustrationBackground}>
                                <Box className={classes.illustrationIcon}>
                                    <img className={classes.illustrationImage} src={timeoutIllustration} alt={translate('sessionTimeout')} />
                                </Box>
                            </Box>
                        </Box>
                        <Box className={classes.copyWrapper}>
                            <Typography className={classes.title}>{title}</Typography>
                            <Typography className={classes.verbiage}>{verbiage1}</Typography>
                            <Button
                                className={classes.returnButton}
                                href={window.location.origin}
                                variant='contained'
                            >
                                {translate('errorPage.returnToLogin')}
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Grid container className={classes.gridContainerFooter}>
                <Footer />
            </Grid>
        </>
    )
}

Component.displayName = 'OktaRegistrationWizard.NoAccess'

Component.propTypes = {
    classes: PropTypes.shape({
        heading: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        registrationRoot: PropTypes.string.isRequired,
        root: PropTypes.string.isRequired,
        verbiage: PropTypes.string.isRequired
    })
}
export default withStyles(Component, styles)
